import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const groupsAdapter = createEntityAdapter({
  selectId: (group) => group._id,
});
const initialState = {
  ui: {
    loading: false,
    fetching_invites: false,
    joining_group: false,
    deletingGroup: false,
    stats: {
      pageCount: 1,
    },
  },
  data: [],
  invites: [],
  deleted_group: groupsAdapter.getInitialState(),
};

export const groupsReducerSlice = createSlice({
  name: 'groups',
  initialState,

  reducers: {
    get_groups_success: (state, { payload }) => {
      state.ui.loading = false;
      const { groups, stats } = payload;
      state.data = groups;
      state.ui.stats = {
        ...stats,
      };
    },
    get_groups_error: (state) => {
      state.ui.loading = false;
    },
    get_groups: (state) => {
      state.ui.loading = true;
    },
    delete_group_success: (state, { payload }) => {
      groupsAdapter.removeOne(state.deleted_group, payload._id);
      state.ui.deletingGroup = false;
    },
    delete_group_error: (state) => {
      state.ui.deletingGroup = false;
    },
    delete_group: (state) => {
      state.ui.deletingGroup = true;
    },
    get_group_invites: (state) => {
      state.ui.fetching_invites = true;
    },
    get_group_invites_success: (state, { payload }) => {
      state.ui.fetching_invites = false;
      state.invites = payload;
    },
    get_group_invites_error: (state) => {
      state.ui.fetching_invites = false;
    },
    join_group: (state) => {
      state.ui.joining_group = true;
    },
    join_group_success: (state, { payload }) => {
      (state.ui.joining_group = false),
        (state.invites = state.invites.filter(
          (invite) => invite.group_id._id !== payload._id,
        ));
    },
    join_group_error: (state) => {
      state.ui.joining_group = false;
    },
  },
});

// Action creators are generated for each case reducer function

export const {
  get_groups_success,
  get_groups_error,
  get_groups,
  delete_group_success,
  delete_group_error,
  delete_group,
  get_group_invites,
  get_group_invites_error,
  get_group_invites_success,
  join_group,
  join_group_error,
  join_group_success,
} = groupsReducerSlice.actions;

export default groupsReducerSlice.reducer;
